import { Accordion, AccordionDetails, AccordionSummary, Avatar, Box, Button, Chip, CircularProgress, Container, Fab, Grid, IconButton, Paper, Stack, Typography, colors } from "@mui/material";
import { variables } from "../../../styles/abstract/variables";
import { AccessTimeFilled, BugReport, Cancel, CancelOutlined, Check, CheckCircle, CheckCircleOutline, Close, Delete, DeleteRounded, Download, ExpandMore, FactCheckRounded, GppBad, GppGood, MenuBook, Report, Warning } from "@mui/icons-material";
import { useContext, useEffect, useRef, useState } from "react";
import { AppContext } from "../../../AppContext";
import { DataContext } from "../../DataContext";
import PhotosModal from "../../map/PhotosModal";
import $data from "../../../services/$data";
import CarbonPhotosModal from "../CarbonPhotosModal";
import ApplicabilityReport from "./ApplicabilityReport";
const tagsLabels = {
  'None': 'None',
  'R_R': 'Red zone - Row',
  'B_R': 'Red zone - Between rows',
  'R_G': 'Green zone - Row',
  'B_G': 'Green zone - Between rows',
  'R_Y': 'Yellow zone - Row',
  'B_Y': 'Yellow zone - Between rows',
  'W': 'Witness',
  'AP': 'Applicability',
  'F': 'Fertilization',
  'PE': 'Pesticides',
  'S': 'Soil management',
  'PR': 'Pruning',
  'H': 'Harvesting',
  'RM': 'Resiudes management',
  'I': 'Irrigation',
  'AN': 'Animals',
  'SOC': 'Soil Organic Carbon',
  'PL': 'Planting',
}
function CarbonApplicability({ parcel, applicabilityInfo, onUpdateParcel }) {
  const downloadRef = useRef(null);
  console.log(parcel)
  const [loading, setLoading] = useState(true);
  const [submitLoading, setSubmitLoading] = useState(false);
  const [photos, setPhotos] = useState([]);
  
  const [report, setReport] = useState(null);
  const [kml, setKml] = useState(null);
  const [applicabilityDoc, setApplicabilityDoc] = useState(null)
  const [photosModal, setPhotosModal] = useState(false);
  // const photosCheck = photos.find(p => p.tag === 'Applicability' && p.parcel === parcel.id);
  const photosCheck = photos.find(p => p.parcel === parcel.id);
  const photosAP = photos.filter(p => p.tag === 'AP' && p.parcel === parcel.id);
  
  console.table(photosAP)
  const getPhotos = async () => {
    setLoading(true);
    try {
      const data = await $data.getPhotos(parcel.project.id);
      setPhotos(data);
    } catch (error) {

    } finally {
      setLoading(false)
    }
  }

  const getReports = async () => {
    setLoading(true);
    try {
      const data = await $data.getReports(`parcel=${parcel.id}`);
      const kml = data.results.find(r => r.tag === 'KML');
      const doc = data.results.find(r => r.tag === 'applicability_report');
      setKml(kml);
      setApplicabilityDoc(doc);
      // setReports(data);
    } catch (error) {

    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    getPhotos();
    getReports();
  }, []);

  const onSubmit = async () => {
    setSubmitLoading(true);
    try {
      await $data.editParcel({ applicability_status: 'In Progress' }, parcel.id)
      // await $data.patchParcelStatus({id: parcel.statusId, parcel: parcel.id, applicability_status: 'In Progress'});
      await onUpdateParcel();
    } catch (error) {
      console.log(error)
    } finally {
      setSubmitLoading(false)
    }
  }

  const renderPhotos = (toDelete = true) => {
    return photos.filter(p => p.parcel === parcel.id && p.tag === 'AP').map((photo, i) => {
      return (
        <Paper key={i} elevation={3} style={{ position: 'relative', backgroundImage: `url("${photo.image}")`, backgroundPosition: 'center', backgroundSize: 'cover' }} sx={{ width: '100px', height: '100px', '&:hover': { cursor: 'pointer', transform: 'scale(1.03)' } }}>
          {photo.tag && <Chip size="small" label={`#${tagsLabels[photo.tag]}`} color="warning" variant="filled" sx={{ position: 'absolute', maxWidth: 'calc(100% - 4px)', bottom: '2px', left: '2px', cursor: 'pointer', whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden' }} />}
          {toDelete && <IconButton sx={{ position: 'absolute', top: '0px', right: '0px' }} size="small" ><Cancel fontSize="small" color="error" /></IconButton>}
        </Paper>
      )
    });
  }

  const renderCondition1 = () => {

    return (
      <Stack spacing={1} sx={{ mb: '20px' }}>
        <Stack sx={{ mb: '10px' }} direction="row" alignItems="flex-start" justifyContent="space-between" spacing={2}>
          <Typography variant="body2">Condtion 1: <strong style={{ color: variables.primary }}>In the last 20 years, parcel was not under: Forest, Transitional woodland/shrub, Wetlands, Water bodies</strong></Typography>
          {Boolean(applicabilityInfo.status) ? <Fab sx={{ width: '28px', minWidth: '28px !important', height: '28px !important', minHeight: '28px !important' }} color="primary" size="small"><Check /></Fab> : <Fab sx={{ width: '28px', minWidth: '28px !important', height: '28px !important', minHeight: '28px !important' }} color="error" size="small"><Close /></Fab>}
        </Stack>
        {!Boolean(applicabilityInfo.status) && <Stack sx={{ mb: '20px' }} direction="row" alignItems="center" justifyContent="space-between" spacing={2}>
          <Typography fontWeight="bold" variant="body2" color="error">Failed to meet the requirements from Condition 1!</Typography>
        </Stack>}
        {!Boolean(applicabilityInfo.status) && (
          <>
            <Stack sx={{ mb: '28px !important' }} direction="row" alignItems="center" spacing={1}>
              <Warning fontSize="small" color="error" />
              <Typography fontWeight="bold" variant="body2" color="error">Manual Review in Progress</Typography>
            </Stack>
            {/* <ul>
                <li><Typography sx={{ mb: '10px' }} variant="caption">Step 1: Download <Button onClick={downloadKML} sx={{ textTransform: 'unset' }} variant="outlined" startIcon={<Download />} size="small"><strong>KML file</strong></Button></Typography></li>
                <li style={{ visibility: 'hidden' }}></li>
                <li><Typography sx={{ mb: '10px' }} variant="caption">Step 2: Import into <Button sx={{ textTransform: 'unset' }} variant="outlined" component="a" size="small" target="_blank" href="https://earth.google.com/web/">Google Earth</Button> and check the time-series</Typography></li>
              </ul> */}
          </>
        )}

      </Stack>
    )
  }

  const renderCondition2 = () => {
    {/* NO PHOTOS ATTACHED */ } {
      if (!photosCheck) {
        return (<>
          {/* CHECK PHOTOS - CONDITION 2 */}
          <Stack sx={{ mb: '20px' }}>
            <Stack sx={{ mb: '10px' }} direction="row" alignItems="center" justifyContent="space-between" spacing={2}>
              <Typography variant="body2">Condtion 2:  <strong style={{ color: variables.primary }}>Crop type is olives or almonds (at least 1 geo-tagged photo of the field must be provided)</strong></Typography>
              <Fab sx={{ width: '28px', minWidth: '28px !important', height: '28px !important', minHeight: '28px !important' }} size="small" color="error"><Close /></Fab>
            </Stack>

            <Stack sx={{ mb: '20px' }} direction="row" alignItems="center" justifyContent="flex-start" spacing={2}>
              <Typography variant="caption" sx={{ ml: '20px' }}>No photos provided</Typography>
              <Button size="small" variant="contained" color="primary" onClick={() => setPhotosModal(true)}>Attach collected photo(s)</Button>
            </Stack>

          </Stack>
          <Stack direction="row" alignItems="center" justifyContent="center">
            <Button disabled onClick={onSubmit} size="small" variant="contained">Submit for applicability review</Button>
          </Stack>
        </>)
      }
    }

    {/* PHOTOS ATTACHED && NOT SUBMITTED - READY TO SUBMIT */ }
    if (photosCheck && parcel.applicabilityStatus === 'Draft') {
      return (
        <>
          {/* CHECK PHOTOS - CONDITION 2 */}
          <Stack sx={{ mb: '20px' }}>
            <Stack sx={{ mb: '10px' }} direction="row" alignItems="center" justifyContent="space-between" spacing={2}>
              <Typography variant="body2">Condtion 2:  <strong style={{ color: variables.primary }}>Crop type is olives or almonds (at least 1 geo-tagged photo of the field must be provided)</strong></Typography>
              <Fab sx={{ width: '28px', minWidth: '28px !important', height: '28px !important', minHeight: '28px !important' }} size="small" color="error"><Close /></Fab>
            </Stack>

            <Stack sx={{ mb: '20px' }} direction="row" alignItems="center" justifyContent="flex-start" spacing={2}>
              {renderPhotos()}
              <Button size="small" variant="contained" color="primary" onClick={() => setPhotosModal(true)}>Attach collected photo(s)</Button>
            </Stack>

          </Stack>
          <Stack direction="row" alignItems="center" justifyContent="center">
            <Button onClick={onSubmit} size="small" variant="contained">Submit for applicability review</Button>
          </Stack>
        </>
      )
    }

    {/* PHOTOS ATTACHED && SUBMITTED */ }
    if (photosCheck && parcel.applicabilityStatus === 'In Progress') {
      return (
        <>
          {/* CHECK PHOTOS - CONDITION 2 */}
          <Stack sx={{ mb: '20px' }}>
            <Stack sx={{ mb: '10px' }} direction="row" alignItems="center" justifyContent="space-between" spacing={2}>
              <Typography variant="body2">Condtion 2:  <strong style={{ color: variables.primary }}>Crop type is olives or almonds (at least 1 geo-tagged photo of the field must be provided)</strong></Typography>
              <Fab sx={{ width: '28px', minWidth: '28px !important', height: '28px !important', minHeight: '28px !important' }} size="small" color="warning"><AccessTimeFilled /></Fab>
            </Stack>

            <Stack sx={{ mb: '20px' }} direction="row" alignItems="center" justifyContent="flex-start" spacing={2}>
              {renderPhotos(false)}
              <Chip size="small" icon={<AccessTimeFilled fontSize="small" />} label={'In Progress'} color="warning" />
            </Stack>

          </Stack>
          <Stack direction="row" alignItems="center" justifyContent="center">
            <Button disabled size="small" variant="contained">Under Review</Button>
          </Stack>
        </>
      )
    }

    {/* PHOTOS ATTACHED && REJECTED */ }
    if (photosCheck && parcel.applicabilityStatus === 'Rejected') {
      return (
        <>
          {/* CHECK PHOTOS - CONDITION 2 */}
          <Stack sx={{ mb: '20px' }}>
            <Stack sx={{ mb: '10px' }} direction="row" alignItems="center" justifyContent="space-between" spacing={2}>
              <Typography variant="body2">Condtion 2:  <strong style={{ color: variables.primary }}>Crop type is olives or almonds (at least 1 geo-tagged photo of the field must be provided)</strong></Typography>
              <Fab sx={{ width: '28px', minWidth: '28px !important', height: '28px !important', minHeight: '28px !important' }} size="small" color="error"><Close /></Fab>
            </Stack>

            <Stack sx={{ mb: '20px' }} direction="row" alignItems="center" justifyContent="flex-start" spacing={2}>
              {renderPhotos()}
              <Stack spacing={2} alignItems="flex-start">
                <Button size="small" variant="contained" color="primary" onClick={() => setPhotosModal(true)}>Attach collected photo(s)</Button>
                <Chip sx={{ width: 'unset !important' }} size="small" icon={<Cancel fontSize="small" />} label={'Rejected'} color="error" />
              </Stack>
            </Stack>

            <Stack sx={{ mb: '20px' }} direction="row" alignItems="center" justifyContent="flex-start" spacing={2}>
              <Typography fontWeight="bold" variant="body2" color="error">Failed to meet the requirements from Condition 2!</Typography>
            </Stack>

          </Stack>
          <Stack direction="row" alignItems="center" justifyContent="center">
            <Button onClick={onSubmit} size="small" variant="contained">Submit for applicability review</Button>
          </Stack>
        </>
      )
    }

    {/* PHOTOS ATTACHED && APPLICABILITY STATUS APPROVED */ }
    if (photosCheck && parcel.applicabilityStatus === 'Approved') {
      return (
        <>
          {/* CHECK PHOTOS - CONDITION 2 */}
          <Stack sx={{ mb: '20px' }}>
            <Stack sx={{ mb: '10px' }} direction="row" alignItems="center" justifyContent="space-between" spacing={2}>
              <Typography variant="body2">Condtion 2:  <strong style={{ color: variables.primary }}>Crop type is olives or almonds (at least 1 geo-tagged photo of the field must be provided)</strong></Typography>
              <Fab sx={{ width: '28px', minWidth: '28px !important', height: '28px !important', minHeight: '28px !important' }} size="small" color="primary"><Check /></Fab>
            </Stack>

            <Stack sx={{ mb: '20px' }} direction="row" alignItems="center" justifyContent="flex-start" spacing={2}>
              {renderPhotos(false)}
              <Chip size="small" icon={<Check fontSize="small" />} label={'Approved'} color="primary" />
            </Stack>
          </Stack>
        </>
      )
    }



    return
  }

  const downloadKML = () => {
    try {
      downloadRef.current.download = `${parcel.name}.kml`;
      downloadRef.current.href = `data:text/plain;charset=utf-8,${parcel.kml}`;
      downloadRef.current.click();

    } catch (e) {
      console.log(e)
    }
  }

  const renderContent = () => {
    if (loading && !applicabilityInfo) {
      return (
        <Stack justifyContent="center" alignItems="center">
          <CircularProgress color="primary" />
        </Stack>
      )

    }

    return (
      <>
        {/* CHECK CORINE LAND COVER - CONDITION 1 */}
        {renderCondition1()}

        {/* CHECK PHOTOS - CONDITION 2 */}
        {renderCondition2()}
      </>
    )
  }

  const getFinalStatus = () => {
    if(parcel.applicabilityStatus === 'In Progress') {
      return (
        <Avatar sx={{ background: variables.warningColor }}><AccessTimeFilled color="white" /></Avatar>
      )
    }

    if(parcel.applicabilityStatus === 'Rejected') {
      return (
        <Avatar sx={{ background: variables.dangerColor }}><GppBad color="white" /></Avatar>
      )
    }

    if(parcel.applicabilityStatus === 'Approved') {
      return (
        <Avatar sx={{ background: variables.primary }}><GppGood color="secondary" /></Avatar>
      )
    }

    return null
  }

  return (
    <>
      <Stack direction="row" spacing={2} alignItems="center" sx={{mb: '25px'}}>
        {getFinalStatus()}
        <Typography color="primary" variant="h5" fontWeight={"bold"}>Applicability Check</Typography>
      </Stack>

      {renderContent()}
      
      {/* {parcel.applicabilityStatus === 'Approved' && !applicabilityDoc && ( */}
        <Stack direction="row" justifyContent="center" sx={{ mt: '20px' }}>
          <Button size="small" variant="contained" color="primary" onClick={() => setReport(parcel)} startIcon={<MenuBook />}>Generate Report</Button>
        </Stack>
      {/* )} */}

         {parcel.applicabilityStatus === 'Approved' && applicabilityDoc && (
        <Stack direction="row" justifyContent="center" sx={{ mt: '20px' }}>
          <Button component="a" href={applicabilityDoc.doc} target="_blank" size="small" variant="contained" color="primary" startIcon={<Download />}>Download Report</Button>
        </Stack>
      )}

      <a ref={downloadRef} ></a>
      {photosModal && <CarbonPhotosModal parcelId={parcel.id} onRefreshPhotos={getPhotos} selectable projectId={parcel.project.id} open={photosModal} photos={photos} onClose={() => setPhotosModal(false)} tag="AP" />}
      {Boolean(report) && <ApplicabilityReport open={Boolean(report)} data={report} photos={photosAP} kml={kml} onClose={(bool) => {setReport(null); if(bool) {getReports()}}} />}
    </>
  )
}

export default CarbonApplicability;